const ErrorCode = {
	AbortError: 'REQUEST_ABORTED_ERROR',
};

export default ErrorCode;
